import { Button } from "@chakra-ui/react";

import { Tag } from "../tag";
import { TagOptionType } from "../tag-select-list/types";

type EditableTagToggleProps<T extends string> = {
  selectedOption?: TagOptionType<T> | null;
};

export const EditableTagToggle = <T extends string>({
  selectedOption,
  ...props
}: EditableTagToggleProps<T>) => {
  return (
    <Button
      {...props}
      paddingInline={2}
      paddingBlock={1}
      borderRadius={6}
      size="sm"
      variant="outline"
      justifyContent="flex-start"
      border="none"
    >
      {selectedOption ? (
        <Tag label={selectedOption.label} colorPalette={selectedOption.color} />
      ) : (
        "-"
      )}
    </Button>
  );
};
